import * as React from 'react';
import Page from 'components/Page';
import { Button, Row, Col } from 'reactstrap';
import { MdAdd, } from 'react-icons/lib/md';
import UserCreate from 'components/UserCreate';
import DynamicTable from 'components/DynamicTable';
import DeleteModal from 'components/DeleteModal';
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';

class UserAgentPage extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      show_form: false,
      show_deleting : false,
      columns: [
        {name: 'id', title: 'ID'},
        {name: 'name', title: 'Nome'},
        {name: 'email', title: 'E-mail'},
        {name: 'updated_at', title: 'Último Login'}
      ],
      reload : false,
      editingObj : null,
      delete_id : -1
    };
    this.addAction = this.addAction.bind(this);
    this.closed = this.closed.bind(this);
    this.closedDelete = this.closedDelete.bind(this);
    this.editAction = this.editAction.bind(this);
    this.deleteAction = this.deleteAction.bind(this);
  }
  addAction(){
    this.setState({ show_form : !this.state.show_form})
  }
  closed(refresh){
    if(refresh){
      this.setState({ show_form : false, reload : !this.state.reload, editingObj : null} )
    }else{
      this.setState({ show_form : false, editingObj : null})
    }
  }
  closedDelete(refresh){
    if(refresh){
      this.setState({ show_deleting : false, reload : !this.state.reload, delete_id : -1} )
    }else{
      this.setState({ show_deleting : false , delete_id : -1})
    }
  }
  editAction(idx, obj){
    this.setState({ show_form : true , editingObj : obj})
  }
  deleteAction(idx, obj){
    this.setState({ show_deleting : true , delete_id : obj.id})
  }
  render() {
    return (
      <Page
        title="Usuários - Fiscais"
        className="UserAgentPage">
        <Row>
          <Col>
            <Button outline onClick={this.addAction}><MdAdd size={25} /> Adicionar</Button>
          </Col>
        </Row>
        <DynamicTable
          route="true"
          user={this.props.user}
          api="admin/user-agent"
          columns={this.state.columns}
          dateFilter="false"
          integratedFilter="false"
          currencyColumns="false"
          showPagingState="false"
          filterState="false"
          integratePag="false"
          deleteAction={this.deleteAction}
          editAction={this.editAction}
          reload={this.state.reload}
        />
        <UserCreate
          api="admin/user-agent"
          title="Fiscal"
          visible={this.state.show_form}
          user={this.props.user}
          editing={this.state.editingObj}
          toggle={this.closed}
        />
        <DeleteModal
          visible={this.state.show_deleting}
          user={this.props.user}
          toggle={this.closedDelete}
          api="admin/user-agent/"
          value={this.state.delete_id}
        />
      </Page>
    );
  }
};

// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
  const currentUser = loginSelectors.getUser(state);
  return {
    user : currentUser
  };
}
export default connect(mapStateToProps)(UserAgentPage)


// WEBPACK FOOTER //
// ./src/pages/UserAgentPage.js